import api from './api';
import { format } from 'date-fns'; // Añadir esta importación

const reporteService = {
  // Obtener estadísticas generales
  getStats: async () => {
    return await api.get('/reportes/stats');
  },

  // Obtener pacientes por especialidad
  getPacientesPorEspecialidad: async (params = {}) => {
    return await api.get('/reportes/pacientes-por-especialidad', { params });
  },

  // Obtener citas por mes
  getCitasPorMes: async (params = {}) => {
    return await api.get('/reportes/citas-por-mes', { params });
  },

  // Obtener datos de reporte genérico según su endpoint
  getReportData: async (endpoint, params = {}) => {
    return await api.get(`/reportes/${endpoint}`, { params });
  },

  // Exportar reporte en formato especificado
  exportReport: async (id, format = 'pdf', params = {}) => {
    return await api.get(`/reportes/${id}/export/${format}`, {
      params,
      responseType: 'blob'
    });
  },

  // Obtener especialistas (para filtros)
  getEspecialistas: async () => {
    return await api.get('/especialistas');
  },

  // Obtener especialidades (para filtros)
  getEspecialidades: async () => {
    return await api.get('/especialidades');
  },

  obtenerProximasCitas: async () => {
  try {
    const response = await api.get('/citas', {
      params: {
        fecha_inicio: format(new Date(), 'yyyy-MM-dd'),
        estado: 'Programada',
        limit: 5
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error obteniendo próximas citas:', error);
    return { citas: [] };
  }
}
};

export default reporteService;